import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import Table from "./Table"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getSpecification } from "store/actions"
import Skeleton from "react-loading-skeleton"
import Breadcrumb from "components/Common/Breadcrumb"
import { CustomPagination } from "components/Common/Pagination"

export default function MasterSpecification() {
  const dispatch = useDispatch()
  const store = useSelector(({ specification }) => specification)
  const history = useHistory()
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
  })
  const [count, setCount] = useState(100)

  useEffect(() => {
    setCount(store?.data?.totalPages)
  }, [store?.data])

  const [filter, setFilter] = useState({
    productName: "",
    item: "",
  })

  const onFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const params = {
    productName: filter.productName,
    item: filter.item,
    page: pagination.page,
    size: pagination.size,
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    dispatch(getSpecification({ ...params, page: 0, size: 10 }))
  }
  useEffect(() => {
    dispatch(getSpecification(params))
  }, [dispatch])

  useEffect(() => {
    dispatch(getSpecification(params))
  }, [pagination])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"仕様マスター"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={3}>
                <TextInputWithLabel
                  label={"商品名"}
                  placeholder={""}
                  value={filter.productName}
                  type="text"
                  name="productName"
                  onChange={onFilter}
                />
              </Col>
              <Col md={3}>
                <TextInputWithLabel
                  label={"項目"}
                  placeholder={""}
                  value={filter.item}
                  type="text"
                  name="item"
                  onChange={onFilter}
                />
              </Col>
              <Col md={3} className="d-flex align-content-end flex-wrap">
                <SButton onClick={onSearch} className="mx-2 button">
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row className="mt-3">
              <div className="d-flex justify-content-end align-self-end mb-3">
                <SButton
                  className="button"
                  onClick={() => history.push("/master/specification/create")}
                >
                  新規追加
                </SButton>
              </div>
              <Col>
                {store.status === "process" ? (
                  <Skeleton count={5} />
                ) : (
                  <>
                    <Table
                      page={pagination.page}
                      size={pagination.size}
                      count={count}
                      content={store.data?.content}
                      params={pagination}
                      setParams={setPagination}
                    />
                  </>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
